import {
  AttendanceInquiryType,
  AttendanceInquiryStatus,
} from '@classpass/protobuf-definitions/lib/web/models/partners/attendance_inquiry';

/**
 * Groups inquiries by their type and response status.
 *
 * @param {Array} inquiries - Array of inquiry objects
 * @param {Map} responses - Map of inquiryId to response status
 * @returns {Object} Grouped inquiries with structure:
 *   {
 *     userNotAllowed: {
 *       allowed: [],
 *       notAllowed: [],
 *     },
 *     classDidNotHappen: {
 *       tookPlace: [],
 *       didNotOccur: [],
 *     },
 *   }
 */
export const groupInquiriesByResponse = (inquiries, responses) => {
  const groupedInquiries = {
    userNotAllowed: {
      allowed: [],
      notAllowed: [],
    },
    classDidNotHappen: {
      tookPlace: [],
      didNotOccur: [],
    },
  };

  inquiries.forEach(inquiry => {
    const response = responses.get(inquiry.inquiryId);
    if (response === undefined) return;

    const isUserNotAllowed =
      inquiry.inquiryType === AttendanceInquiryType[AttendanceInquiryType.ATTENDANCE_INQUIRY_TYPE_USER_NOT_ALLOWED_IN];

    if (isUserNotAllowed) {
      if (response === AttendanceInquiryStatus.ATTENDANCE_INQUIRY_STATUS_RESOLVED_USER_ALLOWED_IN) {
        groupedInquiries.userNotAllowed.allowed.push(inquiry);
      } else if (response === AttendanceInquiryStatus.ATTENDANCE_INQUIRY_STATUS_RESOLVED_USER_NOT_ALLOWED_IN) {
        groupedInquiries.userNotAllowed.notAllowed.push(inquiry);
      }
    } else if (response === AttendanceInquiryStatus.ATTENDANCE_INQUIRY_STATUS_RESOLVED_CLASS_HAPPENED) {
      groupedInquiries.classDidNotHappen.tookPlace.push(inquiry);
    } else if (response === AttendanceInquiryStatus.ATTENDANCE_INQUIRY_STATUS_RESOLVED_CLASS_DID_NOT_HAPPEN) {
      groupedInquiries.classDidNotHappen.didNotOccur.push(inquiry);
    }
  });

  return groupedInquiries;
};
